import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { UpdateShiftComponent } from './update-shift/update-shift.component';
import { AddShiftComponent } from './add-shift/add-shift.component';
import { ShiftsComponent } from './shifts/shifts.component';
import { ShiftDetailComponent } from './shift-detail/shift-detail.component';
import { ShiftInfoComponent } from './shift-detail/shift-info/shift-info.component';
import { DriverShiftComponent } from './shift-detail/driver-shift/driver-shift.component';
import { ShiftBatchComponent } from './shift-detail/shift-batches/shift-batch.component';


 const routes: Routes = [
  { path: '', component: ShiftsComponent },
  { path: 'addShift', component: AddShiftComponent },
  { path: 'updateShift/:id', component: UpdateShiftComponent },

  { path: 'shiftDetail/:Id', component: ShiftDetailComponent,
  children: [
    {path: 'ShifInfo', component: ShiftInfoComponent},
    {path: 'driversShift', component: DriverShiftComponent},
    {path: 'shiftBatches', component: ShiftBatchComponent},

  ]
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class ShiftRoutingModule { }
